import {
  AdditionalFieldInterface,
  CourseInterface,
  SessionsInterface,
} from '@app/interfaces/_index';

import { getSubscriptionTuple } from '@app/utilities/_index';
import { Course } from '../models/_index';
import { Adapter } from './adapter';
import { AdditionalFieldAdapter } from './additional-field.adapter';
import { SessionsAdapter } from './sessions.adapter';

/**
 * Adapt raw service course object to Course model
 * NOTE: The item fields are the default json property names,.
 */

export class CourseAdapter implements Adapter<Course> {
  private addFieldAdapter: AdditionalFieldAdapter;
  private sessionsAdapter: SessionsAdapter;

  constructor() {
    this.addFieldAdapter = new AdditionalFieldAdapter();
    this.sessionsAdapter = new SessionsAdapter();
  }

  /**
   * Convert Docebo course response into Course model
   * @param item - has Course object response Course Interface
   * @param subscriptionId - is not not a Docebo default, so add the courses subscription id to course
   * @returns - adapted Course object to Course object model
   */
  adapt(item: CourseInterface): Course {
    let course: Course;
    if (item && item.data) {
      let subscriptionId = -1;
      let subscriptionSlug = '';

      // NOTE: Docebo doesn't have parent subscription id to course, but
      // set this in the course model to use for filtering and allow courses to
      // reference their parent
      // NOTE: subscription id = 84 is Genesys Cloud Learning Subscription
      // NOTE: subscription id = 189 is PureConnect Learning Subscription
      // NOTE: subscription id = 190 is Genesys Engage Learning Subscription
      // NOTE: subscription id = 497 (Docebo Sandbox and Docebo Production) is Pointillist Learning Subscription
      if (item.data.category && item.data.category.name) {
        const subscriptionTupleObject = getSubscriptionTuple(item.data.category.name);
        subscriptionId = subscriptionTupleObject.subscriptionId;
        subscriptionSlug = subscriptionTupleObject.subscriptionSlug;
      }

      course = new Course(
        subscriptionId,
        subscriptionSlug,
        item.data.id,
        item.data.name,
        item.data.code,
        item.data.description,
        item.data.type,
        item.data.duration,
        item.data.additional_fields
          ? item.data.additional_fields.map((field: AdditionalFieldInterface) =>
              this.addFieldAdapter.adapt(field)
            )
          : [],
        item.data.sessions
          ? item.data.sessions.map((field: SessionsInterface) => this.sessionsAdapter.adapt(field))
          : [],
        false, // This is set by the UI. Default set to false
        item.data.slug_name,
        item.data.enrolled && item.data.enrolled.is_enrolled
      );
    }
    return course;
  }
}
